import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { BASE_URL } from '@ai-platform/ai-utils';

import { StoreProvider } from './store';
import { AppRoutes } from './pages';
import { ScrollRestoration } from './components/ScrollRestoration';
import { UserProvider, ModalProvider } from './contexts';

import './styles/global.scss';

export const App: React.FC = () => {
    return (
        <BrowserRouter basename={BASE_URL}>
            <StoreProvider>
                <UserProvider>
                    <ModalProvider>
                        <ScrollRestoration>
                            <AppRoutes />
                        </ScrollRestoration>
                    </ModalProvider>
                </UserProvider>
            </StoreProvider>
        </BrowserRouter>
    );
};
